import { useSyncExternalStore } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'tc-theme';

function current(): Theme {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'light' || saved === 'dark') return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch { return 'light'; }
}

const listeners = new Set<() => void>();
function emit() { listeners.forEach((l) => l()); }
function apply(theme: Theme) {
  try { document.documentElement.dataset.theme = theme; } catch { /* ignore */ }
}

export function setTheme(theme: Theme) {
  try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  apply(theme);
  emit();
}
export function toggleTheme() { setTheme(current() === 'dark' ? 'light' : 'dark'); }

export function useTheme() {
  const theme = useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => current(),
    () => 'light' as Theme,
  );
  return { theme, setTheme, toggle: toggleTheme };
}
